import { createFileRoute, redirect } from "@tanstack/react-router"

export const Route = createFileRoute(
  "/$organisation/_authenticated/_organisation/individuals/$individualId/regulatory/"
)({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/$organisation/individuals/$individualId/appointments",
      params: {
        organisation: params.organisation,
        individualId: params.individualId,
      },
    })
  },
})
